import { render, staticRenderFns } from "./r-item-kind-page.vue?vue&type=template&id=798c1b36&scoped=true&class=item-kind-page"
import script from "./r-item-kind-page.vue?vue&type=script&lang=js"
export * from "./r-item-kind-page.vue?vue&type=script&lang=js"
import style0 from "./r-item-kind-page.vue?vue&type=style&index=0&id=798c1b36&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798c1b36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('798c1b36')) {
      api.createRecord('798c1b36', component.options)
    } else {
      api.reload('798c1b36', component.options)
    }
    module.hot.accept("./r-item-kind-page.vue?vue&type=template&id=798c1b36&scoped=true&class=item-kind-page", function () {
      api.rerender('798c1b36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item-kind/r-item-kind-page.vue"
export default component.exports